import { z } from 'zod';

// Shared validators / constants used across the feedback-forms schemas.
// Lifted out of the original feedback-forms.ts to remove duplicated
// z.string().min(1).max(45) declarations that were drifting separately
// at the form, field, and RPC-input layers.

// Discord's Label component caps text at 45 characters. We use this for
// both the form's modal title and each field's question — anything
// longer would be silently truncated in the rendered modal, so we lock
// it in at the schema layer.
export const DISCORD_LABEL_MAX = 45;
export const DiscordLabelTextSchema = z.string().min(1).max(DISCORD_LABEL_MAX);

// Per-field description shown below the question label in the Discord
// modal. Optional, nullable in the DB.
export const FIELD_DESCRIPTION_MAX = 100;
export const FieldDescriptionSchema = z
  .string()
  .max(FIELD_DESCRIPTION_MAX)
  .nullable();

// Portal-facing form name shown in the studio's forms list. Never
// surfaced to Discord — the Discord-facing copy lives in `title`.
export const FORM_NAME_MAX = 80;
export const FormNameSchema = z.string().min(1).max(FORM_NAME_MAX);
